import { useContext } from 'react';

import { LabelChip, Paper, Typography, Stack } from '@cast/design-system';

import { useHideHpa } from 'features/cluster/workload-optimization/_hooks/permissions/useHideHpa';

import { AvailableHpaForm } from './AvailableHpaForm';
import { HpaSwitch } from './HpaSwitch';
import { NativeHpaSettings } from './NativeHpaSettings';
import { NoNativeHpaEmptyState } from './NoNativeHpaEmptyState';
import { WorkloadDetailsContext } from '../../../_context';
import { useHpaDisabledReasons } from '../../_hooks/useHpaDisabledReasons';

export const HorizontalRightsizingSettings = () => {
  const { hideHpa } = useHideHpa();

  const { workload } = useContext(WorkloadDetailsContext);
  const { hasNativeHpa } = useHpaDisabledReasons(workload);

  return (
    <Stack data-testid="horizontal-rightsizing-settings">
      <Stack
        direction="row"
        alignItems="center"
        gap={8}
        height={48}
        minHeight={48}
      >
        <HpaSwitch />
        <Typography variant="h6">Horizontal optimization</Typography>

        {hasNativeHpa && hideHpa && (
          <LabelChip size="sm" testId="has-native-hpa-chip">
            Native HPA Detected
          </LabelChip>
        )}
      </Stack>

      {hasNativeHpa ? (
        <NativeHpaSettings />
      ) : (
        <>
          {hideHpa ? (
            <Paper sx={{ py: 18 }}>
              <NoNativeHpaEmptyState />
            </Paper>
          ) : (
            <AvailableHpaForm />
          )}
        </>
      )}
    </Stack>
  );
};
